

export const addClass = (el, className) => el.classList.add(className);
export const _addClass = (el) => className => el.classList.add(className);
export const removeClass = (el, className) => el.classList.remove(className);
export const _removeClass = el => className => el.classList.remove(className);
export const toggleClass = (el, className) => el.classList.toggle(className);

export const _flip = (a) => (b) => C => (b) => (a) => fn(a)(b);


export const getLocalName = attribute => attribute.localName

export const buttonPressedAriaTrue = button => button?.setAttribute('aria-pressed', 'true')

export const buttonPressedAriaFalse = button => button?.setAttribute('aria-pressed', 'false')

export const pauseVideo = (pausePlayButton, video) => {
  removeClass(pausePlayButton,"pause")
  video.pause()
  pausePlayButton.setAttribute("aria-pressed", "true")
}
export const playVideo = (pausePlayButton, video) => {
  addClass(pausePlayButton,"pause")
  video.play()
  pausePlayButton.setAttribute("aria-pressed", "false")
}

export const toggleVideoPlay = (pausePlayButton, video) => 
  pausePlayButton.classList.contains('pause')
    ? pauseVideo(pausePlayButton, video)
    : playVideo(pausePlayButton, video)


export const unMuteVideo = (muteButton, video) => {
    removeClass(muteButton,"muted");
    video.muted = false;
    muteButton.setAttribute("aria-pressed", "true")
}
export const muteVideo = (muteButton, video) => {
  addClass(muteButton,"muted")
  video.muted = true;
  muteButton.setAttribute("aria-pressed", "false")
}

export const toggleVideoMute = (muteButton, video) => {
  muteButton.classList.contains('muted')
    ? unMuteVideo(muteButton, video)
    : muteVideo(muteButton, video)
}

export const dispatchEvent = (eventName, eventObject) => 
  document.dispatchEvent(new CustomEvent(eventName, eventObject))

export const _listenToElement = eventType => callback => (el, variables) => {
  if ( el === undefined || el === null ) {
    return
  }
  el.addEventListener(eventType, event => {
    callback(el, event, variables)
  })
  return el
}
export const _listen = eventType => callback => (el, variables) => {
  document.addEventListener(eventType, event => {
    callback(el, event, variables)
  })
  return el
}

export const _mapFunctions = (...functions) => (...value) => {
  functions.forEach(fn => fn(...value))
}

export const _delegateListen = eventType => queryString => callback => {
  document.addEventListener(eventType, event => {
    if (
      event.target?.classList?.contains(queryString) ||
      event.target?.id == queryString ||
      Array.from(event.target?.attributes)
        .map(getLocalName)
        .find(string => string.includes(queryString))
    ) {
      callback(event.target, event)
    }
    return event.target
  })
}

export const delegateListen = (eventType,queryString, callback) => {
  document.addEventListener(eventType, event => {
    if (
      event.target?.classList.contains(queryString) ||
      event.target.id == queryString ||
      Array.from(event.target.attributes)
        .map(getLocalName)
        .find(string => string.includes(queryString))
    ) {
      callback(event.target, event)
    }
    return event.target
  })
}


export const _setInnerText = text => el => {
  el.innerText = text
  return el
}

export const setInnerText = (el,text)=> {
  el.innerText = text
  return el
}


export const disable = el => {
  el.setAttribute('disabled', 'true')
  return el
}

export const enable = el => {
  el.removeAttribute('disabled')
  return el
}

export const value = value => el => {
  el.value = value
  return el
}

//Just an immutable version of array.push
export const push = (array, value) => [...array, value]

export const update = (array, value) =>
  array.map(arrValue => (arrValue === value ? value : arrValue))


export const setSrc = (el, src) => (el.src = src)

export const cloneAndReplace = (el, targetEl) =>
  targetEl.replaceWith(el.cloneNode(true))


export const _setData = (dataset, string) => el =>
  (el.dataset[`${dataset}`] = string)

export const components = string =>
  Array.from(document.querySelectorAll(`[data-component-${string}]`))

export const component = string => document.querySelector(`[data-component-${string}]`)

export const _componentOf = el => string => el.querySelector(`[data-component-${string}]`)

export const _multiComponentsOf = el => stringArr =>
  stringArr.map(string => {
    const componentOfEl = _componentOf(el)
    return componentOfEl(string)
  })

export const add = (x, y) => x + y

export const _onClick = _listenToElement('click')

export const _delegateOnClick = _delegateListen('click')

export const delegateOnClick = (queryString, callback) =>
  delegateListen('click', queryString, callback)

export const _delegateOnMouseover = _delegateListen('mouseover')

export const _onKeyDown = _listen('keydown')

export const toggleAttr = (item, attr) =>
  item.hasAttribute(attr)
    ? item.removeAttribute(attr)
    : item.setAttribute(attr, '')

export const _setAttr = (attr, value) => item => item.setAttribute(attr, value)
export const setAttr = (element, attr, value) => element.setAttribute(attr, value)
export const getAttr = attr => item => item.getAttribute(attr)
export const getAttribute = (attr, item) => item.getAttribute(attr)
export const hasAttr = attr => item => item.hasAttribute(attr)
export const setHtml = item => html => (item.innerHTML = html)
export const setAttributes = (element, attrs) => {
  for(var key in attrs) {
    element.setAttribute(key, attrs[key]);
  }
}


const setAriaExpandedTrue = _setAttr('aria-expanded', 'true')
const setAriaExpandedFalse = _setAttr('aria-expanded', 'false')

const getAriaExpanded = getAttr('aria-expanded')

export const getAriaPressed = getAttr('aria-pressed')

export const pressedTrue = elem => getAriaPressed(elem) === 'true'

export const setDisabledTrue = _setAttr("disabled", "true")

export const setDisabledFalse = elem => 
  elem.removeAttribute('disabled')

export const disabledTrue = elem => elem?.hasAttribute("disabled")

export const expandedTrue = elem => getAriaExpanded(elem) === 'true'

export const expandedToggle = elem => (expandedTrue(elem) ? setAriaExpandedFalse(elem) : setAriaExpandedTrue(elem))

export const getVariant = (el, variantId) => el?.querySelector(`[ data-variant-id="${variantId}"]`)

// Category: manipulate DOM
export const setTabindex = el => el.setAttribute('tabindex', 0)

export const setTabIndexMinusOne = el => el.setAttribute('tabindex', '-1')

// Category: Utility functions related to libraries or more complex functions
export const goToSlide = (slideEl, swiperInstance) => {
  const $slides = swiperInstance.slides
  $slides.each((index, slide) => {
    if (slide === slideEl) {
      swiperInstance.slideTo(index)
    }
  })
}

// Category: events
export const focus = el => el.focus()

export const clickOn = el => el.click()


// Category: query
export const query = (selector, el = document) => el.querySelector(selector)
export const _queryAll = (selector) => (el = document) => Array.from(el.querySelectorAll(selector))
export const queryAll = (selector, el = document) => Array.from(el.querySelectorAll(selector))
export const datasetOfDatasetQuery = (dataset) => document.querySelector(`[data-${dataset}]`)?.dataset[`${dataset.replace(/-([a-z])/g, g => g[1].toUpperCase())}`]
export const queryLoop = object => Object.values(object).filter(Boolean).map((value) => queryAll(value))
export const getElementFromSelectorWithOffsetHeight = (selector) => {
  const elements = document.querySelectorAll(selector)
  const offsetHeightElement = Array.from(elements).find(element => element.offsetHeight !== 0)
  return offsetHeightElement
}

// Category: get
export const getProductFromEvent = event => event?.detail?.product

export const _closest = string => el => el?.closest(string)

export const _dataset = string => el => el?.dataset[string]

export const getFirstVariantId = productObj => productObj?.variants[0]

export const getName = property=> property?.title

export const getUrlFromHandle = handle => `/products/${handle}`

export const getFirstImage = property => property.images[0]

export function getCookieByName(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

export const getLabelFor = label => document.getElementById(label.htmlFor)

export const getDiference = (a,b) => a - b

export const getKeyEvent = e => e.key
export const hasMatchingProduct = (cart, matchingProductId) => cart.items.find(item => item.id === matchingProductId)

export const getComputedOpacity = el => getComputedStyle(el).opacity

// Category: check for

export const arrayPopulated = array => array.length > 0

export const checkProductType = (type) => product => product.type === type

export const matchesSelector = selector => (el) => el.matches(selector)

// Category: manipulate data
export const _json = string => string && JSON.parse(string)

export const assignTo = (a,b) => {
  a = b
  return a
}

export const assignDatasetTo = (el,dataset,value) => {
  if(falsy(dataset)) return
  el.dataset[dataset] = value
  return el
}

export const _parseInt = string => string && parseInt(string,10)

export const combineIntoStringWithDash = (a,b) => `${a}-${b}`

export const sanitizeString = (str) => {
  return str.toLowerCase().replace(/\s+/g, '').replace(/[^\w\s]/gi, '');
}

export const handleize = (str) => {
  return str.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\s-]/gi, '');
}

const convertPascalCaseToKebabCase = (string) => {
  return string.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}

// Category: Functional JS helpers
export const pipe = (...fs) => (x) => fs.reduce((acc, f) => f(acc), x);
export const doNothing = () => { }
export const when = (pred) => x => whenTrue => (pred(x) ? whenTrue(x) : x)
export const tap = f => x => { f(x); return x }
export const map = f => arr => arr.map(f)

// Category: Async
export const timeout = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Category: ADA 
export const getFocusableElements = (el) =>  el.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable],p') 


// see false, undefined and null as false, and everything else as true, so that an empty string and int value of 0 is true
export const truthy = (value) => {
  if ( value === false || value === undefined || value === null  || value === NaN) {
    return false
  } else {
    return true
  }
}

export const falsy = (value) => {
  if ( value === false || value === undefined || value === null  || Number.isNaN(value) ) {
    return true
  } else {
    return false
  }
}

export const getFirst = arr => {
 return arr[0]
}

export const getPrice = property => property.price

export const getFinalLinePrice = property => property?.final_line_price

export const getId = property => property.id

export const getKey = item => {item.key}

export const getItemsFromEvent = (event) => event?.detail?.cart?.items

export const getQuantity = item => item.quantity

export const getQuantityFromEvent = event => event?.detail?.event_info?.quantity

export const isSameId = (id, otherId) => parseInt(id,10) === parseInt(otherId,10)

export const _isSameId = id => otherId === id === parseInt(otherId)

export const getDispatcher = event => event?.detail?.event_info?.dispatcher

export const validateArray = array => {
  if (falsy(array?.length))  return false
  if (array.length === 0) return false
  return true
}

// getCart function moved to global.js for centralized caching
// Use window.getCart() instead
export const getCart = () => {
  console.warn('⚠️ utils.js getCart() is deprecated. Use window.getCart() instead.');
  return window.getCart();
}

export const detectMob = () => {
  return window.innerWidth < 750
}

